import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import SearchBar from '../searchBar/searchBar.component';

class SummaryTextBox extends PureComponent {
  static propTypes = {
    content: PropTypes.string,
  };

  state = {
    searchBarPhrase: '',
  };

  onSearch = searchBarPhrase => {
    this.setState({
      searchBarPhrase,
    });
    this.scrollToFirstHighlight();
  };

  onCancel = () => this.setState({
    searchBarPhrase: '',
  });

  textBoxRef = div => this.calculationLogContainer = div;

  scrollToFirstHighlight = () => {
    const termFoundElement = this.calculationLogContainer.getElementsByTagName('mark')[0];

    if (typeof termFoundElement !== 'undefined') {
      const offsetPosition = termFoundElement.offsetTop;
      this.calculationLogContainer.scrollTop = offsetPosition - 60;
    }
  };

  render() {
    const {
      content,
    } = this.props;

    const {
      searchBarPhrase,
    } = this.state;

    return (
      <div className="summary">
        <div className="row">
          <div className="col-5 ml-auto">
            <SearchBar
              onCancel={this.onCancel}
              onSearch={this.onSearch}
              value={searchBarPhrase}
            />
          </div>
        </div>
        <div
          ref={this.textBoxRef}
          className="summary-text-box"
        >
          <Highlighter
            className="d-linebreak"
            highlightClassName="summary-text-box-highlight"
            textToHighlight={content}
            searchWords={[searchBarPhrase]}
          />
        </div>
      </div>
    );
  }
}

export default SummaryTextBox;
